import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {ApiEndpoints} from "../shared/ApiEndpoints";
import {of} from "rxjs";

@Injectable()
export class YmlService extends DataService{

  getItem(id) {
    if (!id) {
      return of({error: 'YML id is missing.'});
    }
    return this.getRequest(`${ApiEndpoints.yml}/${id}`);
  }

  getItems() {
    return this.getRequest(ApiEndpoints.yml);
  }

  saveItem(data) {
    if (!data) {
      return of({error: 'YML missing.'});
    }
    if (data.id) {
      return this.putRequest(ApiEndpoints.yml, data);
    } else {
      return this.postRequest(`${ApiEndpoints.yml}`, data);
    }
  }

  deleteItem(id) {
    return this.deleteRequest(`${ApiEndpoints.yml}`, id);
  }
}
